export const oddType = {
  WIN: "WIN",
  PLA: "PLA",
  QIN: "QIN",
  QPL: "QPL",
  IWN: "IWN",
  FCT: "FCT",
  TCE: "TCE",
  QTT: "QTT",
  TRI: "TRI",
  FF: "FF",
  DBL: "DBL",
  TBL: "TBL",
  DT: "DT",
  TT: "TT",
  SIX_UP: "SixUP",
  CWA: "CWA",
  CWB: "CWB",
  CWC: "CWC",
  JKC: "JKC",
  TNC: "TNC",
}
export const singlePools = [
  oddType.WIN,
  oddType.PLA,
  oddType.QIN,
  oddType.QPL,
  oddType.IWN,
  oddType.CWA,
  oddType.CWB,
  oddType.CWC,
  oddType.FCT,
  oddType.TCE,
  oddType.TRI,
  oddType.FF,
  oddType.QTT,
];